const menuScroll = (target) => {
    if($(target).hasClass('active-modal')) {
        window.scroll_position = $(window).scrollTop();
        $('body')
            .css('position', 'fixed')
            .css('overflow', 'hidden')
            .css('width', '100%');
    } else {
        $('body')
            .css('position', '')
            .css('overflow', '')
            .css('width', 'auto');
        $('html').scrollTop(window.scroll_position);
    }
}

const toggleModal = (target) => {
    $(target).slideToggle().toggleClass('active-modal');
    menuScroll(target);
}

$('[data-modal]').on('click', function () {
    const target = $(this).data('modal');
    console.log(target);
    toggleModal('#modal--' + target);

    if (!target.length) {
        return;
    }
});

$('.modal__close').on('click', function () {
    let modal = $(this).parent();
    toggleModal(modal);
});

$(document).keydown(function(event) {
    if (event.keyCode == 27) {
      if( $('.active-modal').length != 0) {
        toggleModal('.active-modal');
      }
    }
});
